import { Patch, applyPatches } from 'immer';
import { xorDecrypt, xorEncrypt } from '../../cryptor/converters';
import {
  getGlobalDatabaseInstance,
  GlobalDatabases,
} from '../manager/databaseManager';
import { UserDBStores } from '../schemas';
import { getUserDBName } from './helpers';
import { decrypt, encrypt } from '../../cryptor/cipher';
import { EntityIdToNameMap } from '../../../sheet/types';

// #region entityIdToName
export const saveEntityIdToNameWAL = async (
  userId: string,
  userFeKey: CryptoKey,
  entityIdToNameMapChanges: Patch[]
) => {
  const db = await getGlobalDatabaseInstance(
    getUserDBName(userId),
    GlobalDatabases.User
  );
  const encEntityToNameMapChanges = await encrypt(
    JSON.stringify(entityIdToNameMapChanges),
    'idb',
    userFeKey
  );

  await db
    .table(UserDBStores.EntityIdToNameMapWAL)
    .put(encEntityToNameMapChanges);
};

export const saveEntityIdToNameSnapshot = async (
  userId: string,
  entityIdToNameMap: EntityIdToNameMap,
  userFeKey: CryptoKey
) => {
  const db = await getGlobalDatabaseInstance(
    getUserDBName(userId),
    GlobalDatabases.User
  );
  const encEntityToNameMap = await encrypt(
    JSON.stringify(entityIdToNameMap),
    'idb',
    userFeKey
  );

  await db.transaction('rw', db.tables, async (db) => {
    await db
      .table(UserDBStores.EntityIdToNameMapSnapshot)
      .put(encEntityToNameMap, userId);

    await db.table(UserDBStores.EntityIdToNameMapWAL).clear();
  });
};

export const readEntityIdToNameMap = async (
  userId: string,
  userFeKey: CryptoKey
): Promise<EntityIdToNameMap> => {
  let snapshot: EntityIdToNameMap = {
    sheetsIdToName: {},
    groupsIdToName: {},
  };

  const db = await getGlobalDatabaseInstance(
    getUserDBName(userId),
    GlobalDatabases.User
  );

  try {
    const encSnapshot = await db
      .table(UserDBStores.EntityIdToNameMapSnapshot)
      .get(userId);

    if (encSnapshot) {
      const decSnapshot = await decrypt(encSnapshot, userFeKey);
      snapshot = JSON.parse(decSnapshot);
    }

    const patches: Patch[] = [];
    await db.table(UserDBStores.EntityIdToNameMapWAL).each(async (encWAL) => {
      const dec = await decrypt(encWAL, userFeKey);
      const patchesArr = JSON.parse(dec);
      if (Array.isArray(patchesArr)) {
        patches.push(...patchesArr);
      }
    });

    return applyPatches(snapshot, patches);
  } catch (err) {
    console.log('err', err);
    return snapshot;
  }
};
// #endregion

// export const getEntityDBInfo = async (userId: string, id: string) => {
//   const db = await getGlobalDatabaseInstance(
//     getUserDBName(userId),
//     GlobalDatabases.User
//   );

//   const entityDBInfo = await db.table(UserDBStores.EntityDBInfo).get(id);

//   if (
//     entityDBInfo &&
//     Array.isArray(entityDBInfo) &&
//     entityDBInfo[2] !== undefined
//   ) {
//     if (!isNaN(Number(entityDBInfo[2]))) {
//       const activeWAL = xorDecrypt(Number(entityDBInfo[2]));
//       return Number(activeWAL);
//     } else {
//       throw new Error('User record has been manipulated');
//     }
//   }

//   return 0;
// };

// export const updateEntityDBInfo = async (
//   userId: string,
//   id: string,
//   activeWAL: number
// ) => {
//   const db = await getGlobalDatabaseInstance(
//     getUserDBName(userId),
//     GlobalDatabases.User
//   );

//   await db
//     .table(UserDBStores.EntityDBInfo)
//     .put([null, null, xorEncrypt(activeWAL)], id);
// };
